import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import MainContainer from '../components/MainContainer';
import { register } from '../actions/userActions';
import { trainingCentres } from '../constants/trainingCentres';

const RegisterScreen = ({ location, history }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [centre, setCentre] = useState('');
  const [message, setMessage] = useState(null);

  const dispatch = useDispatch();
  const { loading, error, userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    if (userInfo) {
      history.push('/dashboard');
    }
  }, [history, userInfo]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('Senhas não combinam');
    } else {
      dispatch(register(name, email, password, centre));
    }
  };

  const getCentres = () => {
    return trainingCentres.sort().map((centre) => (
      <option value={centre} key={centre}>
        {centre}
      </option>
    ));
  };

  return (
    <MainContainer>
      <h1>Cadastrar</h1>
      {error && <Message variant='danger'>{error}</Message>}
      {message && <Message variant='danger'>{message}</Message>}
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <Form onSubmit={submitHandler}>
            <Form.Group controlId='name'>
              <Form.Label>Nome</Form.Label>
              <Form.Control
                type='text'
                placeholder='Informe seu nome'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='email'>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type='email'
                placeholder='Informe seu email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='centre'>
              <Form.Label>Núcleo</Form.Label>
              <Form.Control
                as='select'
                onChange={(e) => setCentre(e.target.value)}
                value={centre}
                required
              >
                <option value={''}>-</option>
                {getCentres()}
              </Form.Control>
            </Form.Group>

            <Form.Group controlId='password'>
              <Form.Label>Senha</Form.Label>
              <Form.Control
                type='password'
                placeholder='Informe sua senha'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='confirmPassword'>
              <Form.Label>Confirmar Senha</Form.Label>
              <Form.Control
                type='password'
                placeholder='Confirme sua senha'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>

            <Button type='submit' variant='primary'>
              Enviar
            </Button>
          </Form>
          <Row className='py-3'>
            <Col>
              Já possui uma conta? <Link to='/login'>Login</Link>
            </Col>
          </Row>
        </Fragment>
      )}
    </MainContainer>
  );
};

export default RegisterScreen;
